module.exports = __webpack_public_path__ + "assets/img/logos/smartum.png";